export const QA_NAME_VIEWING_APPLICANT_PREVIEW = 'viewingApplicantPreview'

export const QA_NAME_VIEWING_APPLICANT_PREVIEW_OPEN_PROFILE =
  'viewingApplicantPreviewOpenProfile'

export const QA_NAME_VIEWING_APPLICANT_PREVIEW_OPEN_VIEWING =
  'viewingApplicantPreviewOpenViewing'

export const QA_NAME_VIEWING_APPLICANT_PREVIEW_RETRY =
  'viewingApplicantPreviewRetry'

export const VIEWING_APPLICANT_PREVIEW_SKELETON_ROWS = 5
